import React, { useState, useMemo, useRef, useEffect } from "react";
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import InputGroup from 'react-bootstrap/InputGroup';
import 'ag-grid-enterprise';
import loaderGif from "../../../assets/loader.gif";
import api from '../../../config/axiosConfig';


const ContactForm = () => {
    const [formData, setFormData] = useState({
        id: null,  // Track if it's a new entry or an edit
        name: '',
        organization: '',
        mobile: '',
        email: '',
        noOfGuests: '',
        notes: '',
        programs: [],
        residenceType: [],
        duration: [],
        source: [],
        subscription: [],
        createddate: '',
        modifieddate: '',
        guestCity: '',
        travelMedium: ''
    });

    const [rowData, setRowData] = useState([]);
    const [isEditMode, setIsEditMode] = useState(false); // To track if we are in edit mode
    const [selectedRow, setSelectedRow] = useState(null);
    const [loader, setLoader] = useState(false);
    
    

    const getData = async () => {
        try {
            const response = await api.get('/contactform');
            setRowData(response.data);
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    
    useEffect(() => {
        getData();
    }, []);
    const gridRef = useRef();

    // Column definitions for Ag-Grid
    const columnDefs = [

        { headerName: 'ID', field: 'id', sort: "desc", filter: 'agNumberColumnFilter' },
        { headerName: 'Name', field: 'name', filter: 'agTextColumnFilter' },
        { headerName: 'Organization Name', field: 'organization', filter: 'agTextColumnFilter' },
        { headerName: 'Guest City', field: 'guestCity', filter: 'agTextColumnFilter' },
        { headerName: 'Travel Medium', field: 'travelMedium', filter: 'agTextColumnFilter' },
        { headerName: 'Mobile No', field: 'mobile', filter: 'agNumberColumnFilter' },
        { headerName: 'E-mail ID', field: 'email', filter: 'agTextColumnFilter' },
        { headerName: 'Number Of Guests', field: 'noOfGuests', filter: 'agNumberColumnFilter' },
        { headerName: 'Number Of Couples', field: 'noOfCouples', filter: 'agNumberColumnFilter' },
        { headerName: 'Notes', field: 'notes', filter: 'agTextColumnFilter' },
        { headerName: 'Programs', field: 'programs', filter: 'agTextColumnFilter' },
        { headerName: 'Residence Type', field: 'residenceType', filter: 'agTextColumnFilter' },
        { headerName: 'Duration', field: 'duration', filter: 'agNumberColumnFilter' },
        { headerName: 'Source', field: 'source', filter: 'agTextColumnFilter' },
        { headerName: 'Subscription', field: 'subscription', filter: 'agTextColumnFilter' },
        { headerName: 'DateRange', field: 'dateRange', filter: 'agTextColumnFilter' },
        { headerName: 'Ip Address', field: 'ip', filter: 'agTextColumnFilter' },
        { headerName: 'City', field: 'city', filter: 'agTextColumnFilter' },
        { headerName: 'Region', field: 'region', filter: 'agTextColumnFilter' },
        { headerName: 'Country', field: 'country', filter: 'agTextColumnFilter' },
        { headerName: 'Timezone', field: 'timezone', filter: 'agTextColumnFilter' },
        { headerName: 'Location', field: 'location', filter: 'agTextColumnFilter' },
        { headerName: 'Browser Info', field: 'browser', filter: 'agTextColumnFilter' },
        { headerName: 'OS Info', field: 'os', filter: 'agTextColumnFilter' },
        { headerName: 'Created At', field: 'createddate', filter: 'agDateColumnFilter',
            valueFormatter: (params) => {
                  const date = new Date(params.value);
                  return date.toLocaleDateString('en-IN');
              }          
            
         },
    ];

    const sideBar = useMemo(() => {
        return {
            toolPanels: [
                {
                    id: 'columns',
                    labelDefault: 'Columns',
                    labelKey: 'columns',
                    iconKey: 'columns',
                    toolPanel: 'agColumnsToolPanel',
                },
                {
                    id: 'filters',
                    labelDefault: 'Filters',
                    labelKey: 'filters',
                    iconKey: 'filter',
                    toolPanel: 'agFiltersToolPanel',
                }
            ],
            defaultToolPanel: '',
        };
    }, []);

    // Server-Side Datasource
    const datasource = {
        getRows: async function (params) {
            try {
                const { request } = params;

                const response = await api.post('/contactform/ag', { ...request });

                const { rows, lastRow } = response.data;

                // Send data back to AG Grid
                params.successCallback(rows, lastRow);
            } catch (error) {
                console.error("Error fetching rows:", error);
                params.failCallback();
            }
        }
    };

    const gridOptions = {
        rowModelType: 'serverSide',
        columnDefs: columnDefs,
        rowHeight: 60,

        defaultColDef: {
            sortable: true,
            filter: true,
            resizable: true,
            floatingFilter: true,
            enableValue: true,
            enableRowGroup: true,
            enablePivot: true,
            filterParams: {
                buttons: ["reset"],
                closeOnApply: true,
            },
        },

        sideBar: sideBar,
        rowGroupPanelShow: 'always',
        rowSelection: 'single',
        columnHoverHighlight: true,
        suppressRowGroupHidesColumns: true,
        cacheBlockSize: 20,
    }

    // Attach the datasource when the grid is ready
    const onGridReady = (params) => {
        params.api.setServerSideDatasource(datasource);
    };

    // Row selection handler
    const onRowSelected = (event) => {
        if (event.node.isSelected()) {
            const selectedRow = event.data;
            // console.log("SelectedRow:", selectedRow)
            setFormData({
                id: selectedRow.id,
                name: selectedRow.name,
                organization: selectedRow.organization,
                mobile: selectedRow.mobile,
                email: selectedRow.email,
                noOfGuests: selectedRow.noOfGuests,
                notes: selectedRow.notes,
                programs: selectedRow.programs,
                residenceType: selectedRow.residenceType,
                duration: selectedRow.duration,
                source: selectedRow.source,
                subscription: selectedRow.subscription,
                guestCity: selectedRow.guestCity,
                travelMedium: selectedRow.travelMedium
            });

            setIsEditMode(true);  // Switch to edit mode
            setSelectedRow(selectedRow)
        }
    };


    return (
        <>
            <Container fluid>
                <Row className="mt-4">
                    <h6 className="text-start">Contact Form List</h6>
                    <div className="ag-theme-alpine" style={{ height: 400, width: '100%' }}>
                        <AgGridReact
                            ref={gridRef}
                            gridOptions={gridOptions}
                            onGridReady={onGridReady}
                            onRowSelected={onRowSelected}
                        />
                    </div>
                </Row>
                <Row className="mt-4 border shadow p-4">
                    {loader && (
                        <div className="loader-overlay">
                            <img src={loaderGif} alt="Loading..." className="loader" />
                        </div>
                    )}
                </Row>
            </Container >
        </>
    );
};

export default ContactForm;